function Footer() {
  return (
    <footer
      className="bg-gray-100 py-6 text-center text-sm text-gray-600"
      data-aos="fade-up" // ✅ scroll effect
      data-aos-delay="100"
    >
      <p>&copy; {new Date().getFullYear()} Karmadeep. All rights reserved.</p>

{/* <p>
  &copy; {new Date().getFullYear()}{" "}
  <a
    href="https://kd-portfolio-five.vercel.app"
    className="text-blue-600 hover:underline"
    target="_blank"
    rel="noopener noreferrer"
  >
    kd-portfolio.vercel.app
  </a>
</p> */}


    </footer>
  );
}

export default Footer;
